<div
    class="page"
    *ngIf="testSessionInformation$ | async as testSessionInformation"
>
    <app-step-progress [steps]="steps"></app-step-progress>
    <div>
        <app-page-title [title]="'Selection Summary'"></app-page-title>
        <br />

        <app-proof-of-identity-selection-summary [testSession]="testSessionInformation$ | async"></app-proof-of-identity-selection-summary>

        <app-proof-of-identity-test-purpose
            *ngIf="!invalidTestSession"
            [testPurposes]="testPurposes$ | async"
            [institutions]="institutions$ | async"
            [subscribedInstitutions]="subscribedInstitutions$ | async"
            [testTypeId]="testSessionInformation.testTypeId"
            [testSession]="testSessionInformation"
            [storedTestPurposeOption]="selectedTestPurposeOption$ | async"
            (selectNewTestPurpose)="onSelectNewTestPurpose($event)"
            [isWebDelivery]="testSessionInformation.isWebDelivery"
            (continue)="onContinue($event)"
        ></app-proof-of-identity-test-purpose>

        <div *ngIf="!isGeneralTest && !continuePressed && brandId === BrandEnum.CELPIP">
            <div class="prompt">Note: Please select <span class="g">CELPIP-General Test</span> instead if you are applying for:
            </div>
            <ul>
                <li>Permanent resident (PR) status</li>
                <li>Real Estate License</li>
                <li>College of Immigration and Citizenship Consultants (CICC)</li>
                <li>Admission to a university, college, or vocational program</li>
                <li>Other </li>
            </ul>
            <div style="text-align: center;">
                <a
                    (click)="redirectWordPress()"
                    class="link"
                >Check test dates for CELPIP-General Test</a>
            </div>
        </div>
    </div>
    <div #proofOfIdentityFormDiv></div>
    <div *ngIf="continuePressed && personalLookupInfo">
        <div class="prompt">
            To complete the registration, you will need <span class="emphasize">ONE</span> of the following acceptable identification documents:
        </div>
        <ol type="A">
            <li *ngFor="let idDoc of personalLookupInfo.idDocTypes">{{idDoc.name}}
                <ng-template #popContent1>
                    <div><img
                            src="https://i.imgur.com/yEkEeDw.png"
                            style="width: 260px; height: 150px;"
                        /></div>
                </ng-template>
                <span>
                    <i
                        *ngIf="idDoc.id == IdDocTypeEnum.UnitedStatesPassportCard"
                        class="fa fa-question-circle-o"
                        [ngbPopover]="popContent1"
                        triggers="mouseenter:mouseleave"
                        placement="top"
                    ></i>
                </span>
                <ng-template #popContent2>
                    <div class="popContent">
                        A Travel Document refers to the following documents:
                        <ul>
                            <li>Refugee Travel Document</li>
                            <li>Travel Document in lieu of passport</li>
                            <li>Certificate of Identity</li>
                        </ul>
                        It does NOT refer to the following, and these are not accepted for the {{brandName}} Test:
                        <ul>
                            <li>NEXUS Card</li>
                            <li>Work Permit</li>
                            <li>Interim Federal Health Certificate of Eligibility</li>
                        </ul>
                    </div>
                </ng-template>
                <span>
                    <i
                        *ngIf="idDoc.id == IdDocTypeEnum.CanadianTravelDocument  || idDoc.id == IdDocTypeEnum.RefugeeTravelDocument"
                        class="fa fa-question-circle-o"
                        [ngbPopover]="popContent2"
                        triggers="mouseenter:mouseleave"
                        placement="bottom"
                    ></i>
                </span>
            </li>
        </ol>

        <div class="panel">
            <p class="highlight">
                IMPORTANT: Test takers who do not bring an acceptable identity document will be refused entry and will not be eligible for a refund or test transfer accommodation.<br><br>
                Please enter your name, date of birth, identity document number, and expiry date exactly as shown on your identification document.
            </p>
            <h5>IDENTIFICATION DOCUMENT NEEDS TO BE:</h5>
            <ul>
                <li>Valid</li>
                <li>Unexpired</li>
                <li>Original (Photocopies are unacceptable)</li>
            </ul>
        </div>

        <div *ngIf="(auth$ | async) === null; else isLoggedIn">
            <div class="my-3">
                <div class="radio">
                    <label><input
                            type="radio"
                            name="selectedChioce"
                            [(ngModel)]="selectedChioce"
                            [value]="1"
                        >
                        Sign in with an existing account</label>
                </div>
                <div class="radio">
                    <label><input
                            type="radio"
                            name="selectedChioce"
                            [(ngModel)]="selectedChioce"
                            [value]="2"
                        >
                        Create a new account</label>
                </div>
            </div>

            <hr />
            <div class="row">
                <div
                    *ngIf="selectedChioce === 1"
                    class="col-sm-6"
                >
                    <app-login-form [isRegFlow]="true" [isAffiliateReg]="true"></app-login-form>
                </div>
                <div
                    *ngIf="selectedChioce === 2"
                    class="col-12"
                >
                    <app-create-account-form
                        [isRegFlow]="true"
                        (postRegAction)="displayLoginForm()"
                    ></app-create-account-form>
                </div>
            </div>
        </div>

        <ng-template #isLoggedIn>
            <app-proof-of-identity-form
                *ngIf="identityInfo"
                [personalLookupInfo]="personalLookupInfo"
                [testSession]="testSessionInformation$ | async"
                [identityInfo]="identityInfo"
                [testDate]="testSessionInformation.testDateTimeUtc"
                (formSubmit)="onFormSubmit($event)"
            ></app-proof-of-identity-form>
        </ng-template>

    </div>
</div>

<app-modal
    #warningSelectionModal
    title="{{warningModalTitle}}"
    body="{{warningModalBody}}"
    (clickPositive)="removeExistingSitting()"
    [isConfirm]="true"
>
</app-modal>
<app-modal
    #notificationModal
    [title]="notificationModalTitle"
    [body]="notificationModalBody"
>
</app-modal>
